import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { PLAN_TYPE } from '@/const/plans';
import { setPlan } from '@/store/checkout';
import { getMainPlan, getPriceByIdAndCurrency } from '@/utils/price';

import { getPlanCheckoutName, getVatValues } from './utils';

export const usePlansOptions = () => {
	return [PLAN_TYPE.TRIAL, PLAN_TYPE.MONTHLY];
};

export const isFeatureChecked = (planName, featureIndex) =>
	planName !== 'trial' || featureIndex >= 5;

export function usePlan() {
	const dispatch = useDispatch();

	const {
		initializing,
		ready,
		prices,
		priceId,
		fullPlan,
		currentPlan,
		vatInfo,
		currency,
		fetchingPrices,
		monthlyPlan,
		trialPlan,
		discount,
		mainPlan
	} = useSelector(state => {
		const {
			prices: pricesList,
			priceId: selectedPrice,
			initCheckout = {},
			getPrices = {}
		} = state.checkout;

		const userDiscount = state.auth?.user?.discount;

		const { country, type: accountType } =
			state.profile.user?.taxInformation || {};

		const currentCurrency =
			state.profile.currency || state.profile.priceCurrency;

		const foundCurrentPlan =
			getPriceByIdAndCurrency(selectedPrice, currentCurrency, pricesList) ||
			{};

		if (
			selectedPrice &&
			foundCurrentPlan?.handlerId &&
			selectedPrice !== foundCurrentPlan.handlerId
		) {
			dispatch(setPlan(foundCurrentPlan.handlerId));
		}

		const userCountry = state.profile.user?.country;

		return {
			initializing: initCheckout?.loading,
			ready: initCheckout?.success,
			prices: pricesList,
			priceId: selectedPrice,
			vatInfo: getVatValues(foundCurrentPlan, {
				country: country || userCountry,
				accountType
			}),
			currentPlan: foundCurrentPlan,
			currency: currentCurrency,
			fetchingPrices: getPrices?.loading,
			discount: userDiscount,
			monthlyPlan: pricesList.find(
				item => item.active && item.name === 'monthly'
			),
			trialPlan: pricesList.find(
				item => item.active && item.name === 'trial'
			),
			mainPlan: getMainPlan(pricesList)
		};
	});

	return {
		initializing,
		ready,
		prices,
		priceId,
		setPriceId: id => dispatch(setPlan(id)),
		fullPlan,
		currentPlan,
		vatInfo,
		currency,
		fetchingPrices,
		monthlyPlan,
		trialPlan,
		discount,
		mainPlan
	};
}

export function usePlanCheckoutName(planName) {
	const { t, i18n } = useTranslation();

	return getPlanCheckoutName(planName, t, i18n);
}
